<template>
  <v-sheet max-width="380" class="mx-auto" color="transparent">
    <v-form
      @submit.prevent="$v.$invalid ? null : submit()"
      ref="form"
      class="mb-10 mt-5"
    >
      <v-div>
        <v-text-field
          :error-messages="fieldErrors('code').length>0?$t(page+'.'+fieldErrors('code')):null"
          @input="$v.code.$touch()"
          @blur="$v.code.$touch()"
          @focus="message='';code=null"
          v-model="code"
          placeholder="000-000-000"
          v-mask="'###-###-###'"
          color="info"
          outlined
          style="font-size:40px;text-align:center"
          @keyup="code.length==11?submit():null"
        />        
        <v-overlay absolute :value="loader">
          <v-progress-circular
            indeterminate
            color="info"
          ></v-progress-circular>
        </v-overlay>
      </v-div>
      <v-btn block color="info" type="submit" :disabled="$v.$invalid" :loading="loader"
        >{{$t(page+'.Send OTP')}}</v-btn
      >
      <v-alert
        v-if="message"
        type="error"
        dark
        dense
        dismissible
        class="mt-4"
      >
    {{message}}
    </v-alert>
    </v-form>
    <div class="text-center">
      <v-btn x-small color="info" @click="back">
        {{$t(page+'.Not received yet?')}}
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
import { mask } from "vue-the-mask";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
export default {
  directives: { mask },
  mixins: [validationMixin],
  validations: {
    code: { required},
  },
  validationMessages: {
    code: {
      required: 'Please enter code',
      code: 'Must be 9 Digits',
    },
  },
  created(){
    const la=window.navigator.userLanguage||window.navigator.language;
    this.$store.dispatch("setLocale",la.substring(0,2));
  },
  data() {
    return {
      page:'Auth',
      errors: null,
      code: null,
      loader: false,
      message:''
    };
  },
  methods: {
      async submit() {
        this.loader=true;
        try{
          const res = await this.$http.post('/auth/checkotp.php', {"code":this.code})    
          if (res.data.errorid=='0'){
            sessionStorage.setItem('jwt', res.data.jwt);
            sessionStorage.setItem('hash', res.data.hash);
            this.$emit("next", { email: this.email });
            this.message=res.data.message;
          }
          else
          {
            this.message=res.data.message;
          }
      } catch(e)
      {
        /*let user2='{"errorid":"0005","message":"Email non censita","level":"6","active":"1","company":"xLogistics","email":"mail@jslab.it","landingpage":"dashboard","avatar":"/static/avatar/nir.jpg","subscriptionlevel":"0","subscriptionexpiry":"2021-01-31 00:00:00.000","credits":".0000","name":"Nir Erlich","currency":"ils","locale":"he"}';
        let user3=JSON.parse(user2);
        this.message=user3.message;*/
      }
      this.loader=false;
    },
    back(){
      this.$emit("prev", { email: this.email });
    },
    /*
    submit() {
      this.loader = true;
      setTimeout(() => {
        this.loader = false;
        this.$emit("next", { code: this.code });
      }, 2000);
    },
    */
    resetForm() {
      // this.form = Object.assign({}, defaultForm)
      // this.$refs.sendpasscode.reset()
      // this.$v.$reset()
    },
  },
};
</script>
